import { withCompInfo } from '@wix/editor-elements-integrations'
import { getScaledFont, parseFontStr } from '@wix/thunderbolt-becky-root'
import type { RichTextBoxCssCarmiData, RichTextBoxDefinition } from '@wix/thunderbolt-components-native'

export const css = withCompInfo<RichTextBoxCssCarmiData, RichTextBoxDefinition>()(
	// @ts-ignore - remove once isOneDocMigrated is added to CompInfo
	['compLayout', 'compProps', 'styleProperties', 'siteFonts', 'isMobileView', 'isOneDocMigrated'],
	// @ts-ignore - remove once isOneDocMigrated is added to CompInfo
	({ compLayout, compProps, styleProperties, siteFonts, isMobileView, isOneDocMigrated }) => {
		const compInfo = { compLayout, compProps, styleProperties, siteFonts, isMobileView }
		return {
			font: parseFontStr(getScaledFont(compInfo, 'fnt', isOneDocMigrated)),
		}
	}
)
